import { providerService } from "services/providersService";
import { AppThunk } from "../store";
import { setProviders, setProvidersCards, setProvidersCollection } from ".";

export const fetchAllProviders = (): AppThunk => async (dispatch) => {
  try {
    const { data } = await providerService.getProviders();
    dispatch(setProviders(data));
  } catch (error) {
    console.error(error);
  }
};
export const fetchAllProvidersCards =
  (providerId: string): AppThunk =>
  async (dispatch) => {
    try {
      const { data } = await providerService.getProvidersTypesCards(providerId);
      dispatch(setProvidersCards(data));
    } catch (error) {
      console.error(error);
    }
  };

export const fetchAllProvidersCollection =
  (providerId: string): AppThunk =>
  async (dispatch) => {
    try {
      const { data } = await providerService.getProvidersTypesCollection(
        providerId
      );
      dispatch(setProvidersCollection(data));
    } catch (error) {
      console.error(error);
    }
  };
